define('module/video',[
    'underscore',
    'jquery',
    'cnf',
    '_pubsub'
], function(_,$,Cnf,Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub;
        
        this.options={
            selector: {
                trigger:'.trigger-video',
                videotype:'[data-videotype]',
                parent:'.ce-video'
            },
            data:{
                videotype:'videotype'
            },
            tween:{
                duration:.6,
                ease:Power0.easeNone
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initElements();
            this.initEvents();
            this.initBorlabsBlockable(Cnf.$app);
            this.initMutationObserver(Cnf.$app);
        };
        
        this.initOptions=function()
        {
            this.$video=Cnf.$app.find(this.options.selector.trigger);
            this.$parent=Cnf.$app.find(this.options.selector.parent);
            this.iVideo=this.$video.length;
            this.oVideo={};
        };

        this.initEvents = function()
        {
            oPubsub.on(Pubsub.INIT_VIDEO, _.bind(function($el) {
                this.initBorlabsBlockable($el);
                this.initMutationObserver($el);
            },this));

            oPubsub.on(Pubsub.DELETE_VIDEO , _.bind(this.triggerDelete, this));
        }
        
        this.initElements=function()
        {
            if(this.iVideo<=0) {
                return;
            }
            
            for(var i=0;i<this.iVideo;i++) {
                this.$video.eq(i).on(Cnf.click, _.bind(function($el) {
                    var tl=new TimelineMax();
                    tl.to($el,this.options.tween.duration,{
                        autoAlpha:0,
                        ease:this.options.tween.ease
                    });
                    tl.add(_.bind(function() {
                        var $video=$el.closest(this.options.selector.parent).find(this.options.selector.videotype);

                        switch($video.data(this.options.data.videotype)) {
                            case 'brightcove':
                                oPubsub.trigger(Pubsub.CREATE_BRIGHTCOVE_PLAYER,$video);
                                break;
                                
                            /**
                             * @see FDZ-602: handled by borlabs blockable content
                            case 'youtube':
                                oPubsub.trigger(Pubsub.CREATE_YOUTUBE_PLAYER,$video);
                                break;
                             */
                                
                            /**
                             * @see FDZ-642: handled by borlabs blockable content
                            case 'vimeo':
                                oPubsub.trigger(Pubsub.CREATE_VIMEO_PLAYER,$video);
                                break;
                             */

                            default:break;
                        }
                    },this));
                    
                },this,this.$video.eq(i)));
            }
        };


        /**
         * init borlabs blockable content
         * 
         * @jira FDZ-602
         * @jira FDZ-642
         * 
         * @date 2022-11-25
         * @date 2023-04-18
         * @author sh@sopg.de
         */
        this.initBorlabsBlockable = function($parent)
        {
            _.each($parent.find(this.options.selector.parent), _.bind(function(el, index) {
                
                var $el = $(el);
                var $video = $el.find(this.options.selector.videotype);

                switch($video.data(this.options.data.videotype)) {
                        
                    case 'youtube':
                        //mark as init to prevent mutation observer on this itemm
                        $el.attr('data-init', true);
                        oPubsub.trigger(Pubsub.CREATE_YOUTUBE_PLAYER,$video);
                        break;

                    case 'vimeo':
                        //mark as init to prevent mutation observer on this itemm
                        $el.attr('data-init', true);
                        oPubsub.trigger(Pubsub.CREATE_VIMEO_PLAYER,$video);
                        break;

                    default:break;
                }
            }, this));
        };

        /**
         * init mutation observer
         * 
         * @jira FDZ-602
         * @jira FDZ-642
         * 
         * @date 2022-11-25
         * @date 2023-04-18
         * @author sh@sopg.de
         */
        this.initMutationObserver = function($parent)
        {
            _.each($parent.find(this.options.selector.parent), _.bind(function(el, index) {

                var $el = $(el);

                //init mutationsobserver on unattached item only
                if(true !== $el.data('init')) {

                    var oMutationObserver = new MutationObserver(_.bind(function() 
                    {
                        var $video=$el.find(this.options.selector.videotype);
        
                        switch($el.data(this.options.data.videotype)) {
                                
                            case 'youtube':
                                oMutationObserver.disconnect();
                                oPubsub.trigger(Pubsub.CREATE_YOUTUBE_PLAYER,$video);
                                break;

                            case 'vimeo':
                                oMutationObserver.disconnect();
                                oPubsub.trigger(Pubsub.CREATE_VIMEO_PLAYER,$video);
                                break;
        
                            default:break;
                        }
                    }, this));
        
                    oMutationObserver.observe(el, {
                        childList: true,
                        characterData: true,
                        subtree: true,
                    }); 
                }
            }, this));
        };

        this.triggerDelete = function($parent)
        {
            _.each($parent.find(this.options.selector.parent), _.bind(function(el, index) {
                
                var $el = $(el);
                var $video = $el.find(this.options.selector.videotype);

                switch($video.data(this.options.data.videotype)) {
                        
                    case 'youtube':
                        oPubsub.trigger(Pubsub.DISPOSE_YOUTUBE_PLAYER, $video);
                        break;

                    default:break;
                }
            }, this));
        };
    
        this.init();
    };
});
